import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
} from '@mui/material';
import i18next from '../../../lang';
import { adminStyles } from '../../../theme/adminStyles';
import UserListView from '../../../components/UserListView';

const ProductMappingUserList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth={false} sx={adminStyles.fullWidthPageContainer}>
      <UserListView
        actionLabel={i18next.t('product_mapping.purchase_settings')}
        onAction={(userId) => navigate(`/admin/product-mappings/${userId}`)}
        statusEditable={false}
        showOrgHierarchy={false}
        storageKeyPrefix="prodMapping"
        showRoleFilter={false}
      />
    </Container>
  );
};

export default ProductMappingUserList;
